import { MfeLoad } from '@carvana/microfrontend';
import { useEffect } from 'react';
import { getMfeCacheBuster } from '@/common/MicroFrontEnds';
import { staticCdnUrl } from '~/constants/environment';

export default function useLoadSoftPullMfe() {
  useEffect(() => {
    MfeLoad({
      files: [
        [
          'SoftPullModule',
          [
            {
              component: 'default',
              chunks: ['styles.css'],
              default: {
                file: 'index.js',
                manifest: `${staticCdnUrl}/softpull-modal-module/assets-manifest.json?v=${getMfeCacheBuster()}`
              }
            }
          ]
        ]
      ]
    });
  }, []);
}
